export const completionRatesOverTimeTestData = {
    "interval": "DAILY",
    "values": [
        {
            "date": 1640995200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641081600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641168000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641254400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641340800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641427200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641513600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641600000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641686400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641772800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641859200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1641945600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642032000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642118400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642204800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642291200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642377600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642464000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642550400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642636800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642723200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642809600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642896000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1642982400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643068800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643155200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643241600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643328000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643414400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643500800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643587200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643673600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643760000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643846400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1643932800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644019200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644105600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644192000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644278400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644364800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644451200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644537600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644624000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644710400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644796800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644883200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1644969600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645056000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645142400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645228800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645315200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645401600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645488000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645574400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645660800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645747200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645833600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1645920000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646006400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646092800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646179200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646265600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646352000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646438400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646524800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646611200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646697600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646784000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646870400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1646956800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647043200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647129600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647216000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647302400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647388800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647475200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647561600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647648000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647734400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647820800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647907200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1647993600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648080000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648166400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648252800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648339200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648425600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648512000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648598400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648684800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648771200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648857600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1648944000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649030400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649116800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649203200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649289600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649376000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649462400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649548800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649635200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649721600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649808000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649894400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1649980800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1650067200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1650153600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1650240000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1650326400000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1650412800000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1650499200000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1650585600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1650672000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1650758400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1650844800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1650931200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1651017600000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1651104000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1651190400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1651276800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1651363200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1651449600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1651536000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1651622400000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1651708800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1651795200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1651881600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1651968000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1652054400000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1652140800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1652227200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1652313600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1652400000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1652486400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1652572800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1652659200000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1652745600000,
            "complete": 2,
            "incomplete": 0
        },
        {
            "date": 1652832000000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1652918400000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1653004800000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1653091200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1653177600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1653264000000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1653350400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1653436800000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1653523200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1653609600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1653696000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1653782400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1653868800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1653955200000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1654041600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1654128000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1654214400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1654300800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1654387200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1654473600000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1654560000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1654646400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1654732800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1654819200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1654905600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1654992000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1655078400000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1655164800000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1655251200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1655337600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1655424000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1655510400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1655596800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1655683200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1655769600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1655856000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1655942400000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1656028800000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1656115200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1656201600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1656288000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1656374400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1656460800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1656547200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1656633600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1656720000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1656806400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1656892800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1656979200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1657065600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1657152000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1657238400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1657324800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1657411200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1657497600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1657584000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1657670400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1657756800000,
            "complete": 3,
            "incomplete": 0
        },
        {
            "date": 1657843200000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1657929600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658016000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658102400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658188800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658275200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658361600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658448000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658534400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658620800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658707200000,
            "complete": 1,
            "incomplete": 1
        },
        {
            "date": 1658793600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658880000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1658966400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1659052800000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1659139200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1659225600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1659312000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1659398400000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1659484800000,
            "complete": 0,
            "incomplete": 1
        },
        {
            "date": 1659571200000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1659657600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1659744000000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1659830400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1659916800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1660003200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1660089600000,
            "complete": 0,
            "incomplete": 2
        },
        {
            "date": 1660176000000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1660262400000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1660348800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1660435200000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1660521600000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1660608000000,
            "complete": 1,
            "incomplete": 0
        },
        {
            "date": 1660694400000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1660780800000,
            "complete": 0,
            "incomplete": 0
        },
        {
            "date": 1660867200000,
            "complete": 0,
            "incomplete": 0
        }
    ]
}